import { get } from 'local-storage';

const ENABLE_TRACKING_EVENTS_LS_KEY = 'OTT/avia/enableTrackingEvents';
export const shouldLogEvents = (): boolean => {
  const isDev = __DEV__;
  const isTrackingAllowed = Boolean(get(ENABLE_TRACKING_EVENTS_LS_KEY));

  return isDev && isTrackingAllowed;
};
